import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slice/getUserIdSlice";
import rolesReducer from "./slice/getRolesPermissionListSlice";
import UsersReducer from "./slice/getAllUsersSlice";
import UserbyIdReducer from "./slice/getUserByIdSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./rootReducer";
import onboardingFormReducer from './slice/onboardingFormSlice'
import getInvitedUserDetailsReducer from './slice/getInvitedUserDetailsSlice';
import loaderReducer from "./slice/loaderSlice";
import employeesReducer from "./slice/getEmployeeListSlice";
import existingEmployeesReducer from "./slice/getExistingEmpListSlice";
import searchReducer from './slice/searchDataSlice';
import panelsReducer from './slice/panelsSlice';
import dropdownListReducer from './slice/getDropdownListSlice';
import TokenDetailsReducer from './slice/verifyTokenSlice';
import joiningDetailsReducer from './slice/joiningDetailsSlice';
import workingModeShiftReducer from './slice/workingMode&ShiftSlice';
import designationReducer from './slice/designationListSlice';
import managePasswordApiReducer from './slice/managePasswordApiSlice';
import postPolicyAcceptReducer from './slice/postPolicyAcceptSlice';
import policiesReducer from "./slice/policiesSlice";
import getPreOnboardingDocsByIdReducer from './slice/getPreOnboardingDocsByIdSlice';
import getMyProfileReducer from './slice/myProfileSlice';
import announcementsReducer from "./slice/announcementsSlice";
import dashboardReducer from "./slice/dashboardChartSlice";
import updateEmployeeProfileReducer from "./slice/updateEmployeeProfileSlice"
import getExportCandidateDataReducer from "./slice/getExportCandidateDataSlice"
import supportReducer from "./slice/supportSlice";
import UpcomingHolidayReducer from "./slice/getUpcomingHolidaySlice";
import getAllHolidayReducer from "./slice/getAllHolidaySlice";

import departmentsReducer from "./slice/getDepartmentsSlice";
import designationsReducer from "./slice/getDesignationsSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["forms"], 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
import partialCandidateReducer from "./slice/getPartialCandidateDataSlice";
import permissionReducer from "./slice/getAllPermissionListSlice";
import configReducer from "./slice/getAllConfigurationListSlice";
import userPerRoleReducer from "./slice/getUserPerRoleSlice";
import candidateStatusReducer from "./slice/updateCandidateStatusSlice";
import getInvitedActivityReducer from "./slice/getInvitedActivitySlice";
import permissionsByIdReducer from "./slice/getPermissionListByIdSlice";
import managePasswordReducer from "./slice/managePasswordSlice";
import activeMenuReducer from "./slice/activeMenuSlice"; 
import activeEmpReducer from "./slice/getAllActiveEmpSlice";
import createCredentialsReducer from './slice/createCredentialSlice';
import filesUploadReducer from "./slice/filesUploadSlice";
import empAccountStatusReducer from "./slice/empAccountStatusSlice";
import supportConfigReducer from "./slice/supportConfigSlice";
import profileUpdateReducer from "./slice/profileUpdateSupportSlice";
import departmentReducer from "./slice/departmentSlice";

export const Store = configureStore({
  reducer: {
    getUserId: userReducer,
    rolePermission: rolesReducer,
    Users: UsersReducer,
    User: UserbyIdReducer,
    persistedReducer,
    Candidates: partialCandidateReducer,
    Permissions: permissionReducer,
    Configurations: configReducer,
    userPerRole: userPerRoleReducer,
    candidateStatus: candidateStatusReducer,
    preOnboardingForm:onboardingFormReducer,
    getInvitedUserDetailsById:getInvitedUserDetailsReducer,
    ActivityList:getInvitedActivityReducer,
    PermissionsById: permissionsByIdReducer,
    loader: loaderReducer,
    managePassword: managePasswordReducer,
    employees: employeesReducer,
    SearchData :searchReducer,
    panels: panelsReducer,
    dropdownList:dropdownListReducer,
    TokenDetails:TokenDetailsReducer,
    activeMenu: activeMenuReducer,
    JoiningDetails:joiningDetailsReducer,
    workingModeShift: workingModeShiftReducer,
    designation: designationReducer,
    department: departmentReducer,
    activeEmp: activeEmpReducer,
    createCredentials: createCredentialsReducer,
    managePasswordApi:managePasswordApiReducer,
    postPolicyAccept: postPolicyAcceptReducer,
    policies: policiesReducer,
    filesUpload: filesUploadReducer,
    getPreOnboardingDocsById:getPreOnboardingDocsByIdReducer,
    Myprofile: getMyProfileReducer,
    announcements: announcementsReducer,
    departments: departmentsReducer,
    designations: designationsReducer,
    dashboard: dashboardReducer,
    employeeProfile: updateEmployeeProfileReducer,
    empAccountStatus: empAccountStatusReducer,
    exportCandidateData: getExportCandidateDataReducer,
    existingEmployees: existingEmployeesReducer,
    support: supportReducer,
    holidayData: UpcomingHolidayReducer,
    allHolidayData:getAllHolidayReducer,
    supportConfig: supportConfigReducer,
    profileUpdate: profileUpdateReducer,
    holidayData: UpcomingHolidayReducer,
    allHolidayData:getAllHolidayReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),

});

export const persistor = persistStore(Store);
